import service from '@/utils/server';

const modName='/bd/neoLog/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//rePush
export const rePush = data => {
  return service({
    url: modName + 'rePush/'+data,
    method: 'post'
  });
};

//rePushBatch
export const rePushBatch = data => {
  return service({
    url: modName + 'rePushBatch',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/log/neoLog/api/index.js